<template>
    <v-container fluid class="max-width">
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Uom Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/prices">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>
            <v-card-text>

                <v-row>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-row>

                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" sm="12" md="12">
                        <!-- start of table -->
                        <v-data-table :loading="loader" :mobile-breakpoint="0" loading-text="Loading Products........"
                            :items-per-page="pageItems" :headers="headers" :items="products" :search="search">

                            <!-- action template -->
                            <template v-slot:item.hasInventory="{ item }">
                                <span v-if="item.hasInventory == 'yes'" style="color: blue">{{ item.hasInventory
                                    }}</span>
                                <span v-if="item.hasInventory == 'no'" style="color: red">{{ item.hasInventory }}</span>
                            </template>
                            <!-- end -->

                            <!-- action template -->
                            <template v-slot:item.action="{ item }">
                                <v-btn color="editIcon" text :to="`/uom-product/${item.id}`"
                                    icon><v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <!-- end -->

                            <!-- action template -->
                            <template v-slot:item.print="{ item }">
                                <v-btn color="accent" text
                                    :to="`/product-barcode/${item.id}`"><v-icon>mdi-print</v-icon> Print Barcode
                                </v-btn>
                            </template>
                            <!-- end -->

                            <!-- action template -->
                            <template v-slot:item.deleteProduct="{ item }">
                                <v-btn color="red" @click="openDeleteModal(item)" text><v-icon left>mdi-close</v-icon>
                                    Disable Product
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                        <!-- end -->
                    </v-col>
                </v-row>

                <!-- product dialog modal-->
                <v-dialog v-model="deleteDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title> Delete / Disable Product </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="deleteDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row class="text--primary subtitle-2">
                                    <v-col cols="12">
                                        Are you sure you want to delete / disable this product?
                                    </v-col>
                                    <v-col cols="12">
                                        <span style="font-size: 20px">{{ productItem.Name }}</span>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="red" dark :loading="loader" @click="deleteProduct">Yes,
                                            Disable</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of modal-->
            </v-card-text>
        </v-card>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    computed: {
        subscriberId() {
            return localStorage.getItem("subscriber_id");
        },
    },
    data: () => ({
        search: "",
        deleteDialog: false,
        productItem: {},
        loader: false,
        pageItems: 500,
        headers: [
            { text: "Item Code", value: "ItemCode" },
            { text: "Product Name", value: "Name" },
            { text: "Barcode", value: "BarCode" },
            { text: "Action", value: "action" },
        ],
        products: [],
        fields: {
            Product: "Name",
            BaseUnit: "baseUnit",
        },
    }),
    methods: {
        openDeleteModal(data) {
            this.productItem = data;
            this.deleteDialog = true;
        },
        generateBarcodes() {
            // this.$store.commit("btnLoader", false);
            console.log(" subscriber id", this.subscriberId);

            const self = this;
            this.loader = true;
            this.$store
                .dispatch("get", `/generate-barcodes/${this.subscriberId}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.getProducts();
                        self.loader = false;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getProducts() {
            this.$store.commit("btnLoader", false);
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("get", `/products-uom`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.products = res.ResponseData;
                        self.loader = false;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        deleteProduct() {
            const url = `/delete/product/${this.productItem.id}`;
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("remove", url)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        location.reload();
                    } else {
                        self.loader = false;
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        this.getProducts();
    },
};
</script>